'use strict'

import store from '../store'

class WaitUtil {
  static waitStart (name) {
    if (store.state && store.state.wait) {
      store.state.wait.waitingFor.push(name)
    }
  }

  static waitEnd (name) {
    if (store.state && store.state.wait) {
      store.state.wait.waitingFor.splice(store.state.wait.waitingFor.indexOf(name), 1)
    }
  }

  static pushStart () {
    this.waitStart('routing')
  }

  static pushEnd () {
    this.waitEnd('routing')
  }
}

export default WaitUtil
